import { Create, useForm } from '@refinedev/antd';
import { message } from 'antd';
import { useState } from 'react';

import { PackageItem } from '@/model/Logistic/PackageItem/PackageItem';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

import ReceptionForm from './ReceptionForm/ReceptionForm';

export const ReceptionCreate = () => {
  const { packageItemRepository, packageRepository } = useRepositoriesContext();
  const [saveAddress, setSaveAddress] = useState(false);
  const [packageItems, setPackageItems] = useState<PackageItem[]>([]);
  const { formProps, saveButtonProps } = useForm<Shipment>({
    successNotification: {
      message: 'Recepción creada correctamente',
      type: 'success',
    },
    onMutationSuccess(receptionResponse) {
      if (saveAddress) {
        void packageRepository.saveNewAddress(receptionResponse.data).catch(error => {
          message.error('Ocurrió un error al guardar la nueva dirección.');
          console.error('Error saving new address:', error);
        });
      }

      void packageItemRepository
        .savePackageItems(packageItems, receptionResponse.data.id)
        .catch(error => {
          message.error('Ocurrió un error al guardar los items de la recepción.');
          console.error('Error saving package items:', error);
        });
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <ReceptionForm
        formProps={formProps}
        packageItems={packageItems}
        setPackageItems={setPackageItems}
        setSaveAddress={setSaveAddress}
      />
    </Create>
  );
};
